import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function*() {
    yield takeLatest(ACTION.FETCH_DETAIL_DELIVERY_REQUEST.REQUEST, saga.fetchDetailDeliveryRequest);
    // yield takeLatest(ACTION.FETCH_DETAIL_DELIVERY_REQUEST.SUCCESS, saga.fetchDetailDeliveryRequestSuccess);
    yield takeLatest(ACTION.SHOW_DETAIL_DELIVERY_REQUEST, saga.showDetailDeliveryRequest);
    yield takeLatest(ACTION.HIDE_DETAIL_DELIVERY_REQUEST, saga.hideDetailDeliveryRequest);
}